module.exports = __webpack_public_path__ + "static/media/icon_check.19d253ee.svg";